import MojitoCore from 'mojito/core';
import SelectionCardClassic from './classic/index.js';
import SelectionCardAvantgarde from './avantgarde/index.js';

const UIViewFamily = MojitoCore.Presentation.UIViewFamily;

/**
 * Selection card. Renders
 * {@link Mojito.Modules.EventCards.Selection.Classic.view|SelectionCardClassic} or
 * {@link Mojito.Modules.EventCards.Selection.Avantgarde.view|SelectionCardAvantgarde} depending on
 * the active design style. Props are defined on
 * {@link Mojito.Modules.EventCards.Selection.SelectionCardPropTypes|SelectionCardPropTypes}.
 *
 * @function SelectionCard
 * @name view
 *
 * @memberof Mojito.Modules.EventCards.Selection
 */
export default UIViewFamily('SelectionCard', {
    classic: SelectionCardClassic,
    avantgarde: SelectionCardAvantgarde,
});
